// Generated by Melange

import ContainerModuleCss from "../shared/container.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import Clsx from "clsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = ContainerModuleCss;

function Container(Props) {
  let children = Props.children;
  let className = Props.className;
  let tmp = {
    className: Clsx(className, css.root)
  };
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  return JsxRuntime.jsx("div", tmp);
}

const make = Container;

export {
  make,
}
/* css Not a pure module */
